import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { EmailAndSMSService } from 'src/app/services/operations/EmailAndSMS.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';

@Component({
    selector: 'app-transactionpopup',
    templateUrl: 'transactionsuccess.component.html',
    standalone: false
})
export class TransactionSuccessPopupComponent implements OnInit {
    selectedEmailTemplate = null;
    selectedSMSTemplate = null;
    public PhoneNumberMask: String = '(000)000-0000';

    @Input() emailTemplates = [];
    @Input() smsTemplates = [];
    @Input() facilityId;
    @Input() transactionType;
    @Input() inquiryNumber;
    @Input() ReservationNumber;
    @Input() leaseNumber;
    @Input() receiptNumber;
    @Input() isQuickStart: boolean = false;
    @Input() ExistingTenantDetails;
    @Output() emitgoToModule: EventEmitter<any> = new EventEmitter<any>();
    isEmailChecked :boolean = false;
    enableEmail = false;
    isEmailDisabled: boolean = true;
    enablesms = false;
    emailBox = '';
    phoneNumber = '';
    isSMSChecked: boolean = false;
    isSmsDisabled: boolean = true;
    modalRef: BsModalRef;
    @ViewChild('printform', { static: true }) printform: NgForm;
    @ViewChild('transactionPopup', { static: true }) transactionPopup: ModalDirective;
    emailPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
    toasterConfig = {
      closeButton: true,
      timeOut: 4500,
      easing: 'ease-out',
      progressBar: true,
      positionClass: 'toast-top-right',
      tapToDismiss: true,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'slideUp'
    };
    modalConfig ={
      backdrop: 'static'
    }
    constructor(private facOpsDataService: FacOpsDataService,
      private emailAndSmsService: EmailAndSMSService,
      private toaster: ToastrService,
      private userSessionService: UserSessionService,
      private customerDataService: CustomerDataService) { }

    ngOnInit(): void {
          this.printform.form.addControl('email', new FormControl(Validators.pattern(this.emailPattern)));         
     }

     ngOnChanges(changes: SimpleChanges): void {
      var emailTemplatechange = changes['emailTemplates'];
      var smsTemplatechange = changes['smsTemplates'];
      if (emailTemplatechange || smsTemplatechange) {
        this.setDefaultTemplates();
      }
       if (this.facOpsDataService.contactInfo) {
         let tenantInfo = this.facOpsDataService.contactInfo;
         this.emailBox = tenantInfo.NoEmail ? '' : tenantInfo.BusinessAccount == true && tenantInfo.CompanyEmail ? tenantInfo.CompanyEmail : tenantInfo.Email;
         this.phoneNumber = this.isQuickStart ? (this.ExistingTenantDetails != null ? this.ExistingTenantDetails.CellPhone : (tenantInfo.CellPhoneNumber  ?? tenantInfo.Phone)) : tenantInfo.CellPhoneNumber;
         if (tenantInfo.SendSMSAlerts && this.phoneNumber && this.smsTemplates.length)
           this.isSmsDisabled = false;
         else {
           this.isSmsDisabled = true;
         }
         if (this.emailTemplates.length)
           this.isEmailDisabled = false;
         else {
           this.isEmailDisabled = true;
         }
       }
       if(this.customerDataService.customerInfo){
         let tenantInfo = this.customerDataService.customerInfo;
         this.emailBox = tenantInfo.NoEmail ? '' : tenantInfo.BusinessAccount == true && tenantInfo.CompanyEmail ? tenantInfo.CompanyEmail : tenantInfo.Email;
         this.phoneNumber = tenantInfo.CellPhone;
          if (tenantInfo.SMS && this.phoneNumber && this.smsTemplates.length)
           this.isSmsDisabled = false;
         else {
           this.isSmsDisabled = true;
         }
         if (this.emailTemplates.length)
           this.isEmailDisabled = false;
         else {
           this.isEmailDisabled = true;
         }
       }
     }
     setDefaultTemplates() {
      if(this.emailTemplates.length) {
        if(this.emailTemplates.some((ele) => ele.DefaultTemplate)) {
          this.selectedEmailTemplate = this.emailTemplates.find((item) => item.DefaultTemplate).LetterId;
        } else {
          this.selectedEmailTemplate = this.emailTemplates[0].LetterId;
        }
      }
        if(this.smsTemplates.length) {
        if(this.smsTemplates.some((ele) => ele.DefaultTemplate)) {
          this.selectedSMSTemplate = this.smsTemplates.find((item) => item.DefaultTemplate).LetterId;
        } else {
          this.selectedSMSTemplate = this.smsTemplates[0].LetterId;
        }
      }
     }



     colonSepToAddressEmail = (control: AbstractControl): { [key: string]: any } | null => {
        const emails = control.value.split(';');
        const forbidden = emails.some(email => Validators.email(new FormControl(email)));
        let emailFormat = new RegExp('^([a-zA-Z0-9._]+@[a-zA-Z0-9]+[.-]?[a-zA-Z0-9]+[.]{1}[a-zA-Z]{2,}(,|;)?)+$');
        let top = emails.every(email => emailFormat.test(email) )
        return (!forbidden && top) ? null : { 'toAddress': { value: control.value }};
      };
    
      colonSepCCAddressEmail = (control: AbstractControl): { [key: string]: any } | null => {
        const emails = control.value.split(';');
        const forbidden = emails.some(email => Validators.email(new FormControl(email)));
        let emailFormat = new RegExp('^([a-zA-Z0-9._]+@[a-zA-Z0-9]+[.-]?[a-zA-Z0-9]+[.]{1}[a-zA-Z]{2,}(,|;)?)+$');
        let top = emails.every(email => emailFormat.test(email) )
        return (!forbidden && top) ? null : { 'ccAddress': { value: control.value }};
      };


  openTRansactionPopup() {
      this.transactionPopup.show();
    }

    onChangeEmailTemplate(templateId) {
      this.selectedEmailTemplate = templateId;
      console.log('email template changed', templateId);
    }
    
    onChangeSMSTemplate(templateId) {
      this.selectedSMSTemplate = templateId;
      console.log('sms template changed', templateId);
    }

  onEmailCheck(eve) {
    if (eve.target.checked) {
      this.enableEmail = true;
    }
    else {
      this.enableEmail = false;
    }
  }

    onsmscheck(eve) {
      if (eve.target.checked) {
        this.enablesms = true;
      }
      else {
        this.enablesms = false;
      }
    }

    goToHost() {
      this.transactionPopup.hide();
      if (this.isEmailChecked) {
        this.sendEmail();
      }
      if (this.isSMSChecked) {
        this.sendSMS();
      }
      this.emitgoToModule.emit(true);
    }

    sendSMS() {
      let smsList = [];
      let obj = {
        InquiryNo: this.inquiryNumber ? this.inquiryNumber : null,
        ReservationNo:  this.ReservationNumber ? this.ReservationNumber : null,
        LeaseNo: this.leaseNumber ? this.leaseNumber : null,
        FacilityId: this.facilityId,
        TransactionTypeId: this.transactionType,
        SelectedTemplateId: this.selectedSMSTemplate
      };
      smsList.push(obj);
      this.emailAndSmsService.composeSMS(smsList).subscribe((response: any[]) => {
        if(response[0].Success) {
          this.toaster.success('SMS Sent Successfully!', 'Success', this.toasterConfig);
         } else {
          this.toaster.error('Failed to send SMS!', 'Failure', this.toasterConfig);
         }
        }, err => {
          this.toaster.error('Failed to send SMS!', 'Failure', this.toasterConfig);
        });
            this.isSMSChecked = false;
    }

    sendEmail() {
      let emailList = [];
      let obj = {
        InquiryNo: this.inquiryNumber ? this.inquiryNumber : null,
        ReservationNo: this.ReservationNumber ? this.ReservationNumber : null,
        LeaseNo: this.leaseNumber ? this.leaseNumber: null,
        FacilityId: this.facilityId,
        ToEmailAddress: this.emailBox,
        InvoiceNumber: null,
        ReceiptNumber: this.receiptNumber ? this.receiptNumber: null,
        TransactionTypeId: this.transactionType,
        TenantLettersAndNoticesIds: [],
        TenantAlternateLettersAndNoticesIds: [],
        SendToAlternate: true,
        SendToPrimary: true,
        IpAddress: '',
        SelectedTemplateId: this.selectedEmailTemplate
      }
      emailList.push(obj);
      this.emailAndSmsService.composeEmail(emailList).subscribe((response: any[]) => {
        if (response[0].Success) {
          console.log('composeEmail response', response);
        this.toaster.success('Email Sent Successfully', 'Success', this.toasterConfig);
        }
       else {
        this.toaster.error('Failed to send email', 'Failure', this.toasterConfig);
      }
    });
     this.isEmailChecked = false;
    }
}
